<template>
    <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="member_id" :loading="dataListLoading"
        :scroll="{ x: x }" :row-selection="rowSelection">
        <template slot="enable" slot-scope="enable">
            <a-tag :color="enable == 1 ? 'green' : enable == 2 ? 'red' : 'red'">{{ enable == 1 ? '有效' : enable ==
                2 ? '无效' : '已退会' }}</a-tag>
        </template>
        <template slot="process_status" slot-scope="process_status, row">
            <a-tooltip>
                <template slot="title" v-if="process_status == 3">
                    核对不通过原因： {{ row.process_reason }}
                </template>
                <a-tag :color="process_status == 1 ? 'blue' : process_status == 2 ? 'green' : 'red'">{{
                    process_status
                        == 1 ? '待核对' :
                        process_status ==
                            2 ? '核对通过' : '核对不通过' }}</a-tag>
            </a-tooltip>
        </template>
        <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="p-5" v-permission="['admin:member:receivePay']"
                @click="$emit('shoukuanshenhe', [row.member_id])">
                费用核对
            </a-button>
            <a-button type="link" class="p-5" v-permission="['admin:member:detail']"
                @click="$emit('addOrUpdateHandle', { member_id: row.member_id, readonly: true })">
                查看
            </a-button>
            <a-button type="link" class="p-5" v-permission="['admin:member:update']"
                @click="$emit('addOrUpdateHandle', { member_id: row.member_id })">
                编辑
            </a-button>
            <a-button type="link" class="p-5" v-permission="['admin:member:delete']"
                @click="$emit('deleteHandle', row.member_id)">
                删除
            </a-button>
        </template>
    </a-table>
</template>
<script>
export default {
    props: ['columns', 'dataList', 'dataListLoading', 'x', 'customer_id', 'rowSelection']
}
</script>